import React from "react";

const DAY_LABELS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
const DEFAULT_START = "09:00";
const DEFAULT_END = "18:00";

// Editor de horario por doctor contra doctor_availability (S5b). `value` es un arreglo
// plano de franjas {day_of_week, start_time, end_time} (sin id -- el backend reemplaza
// el set completo al guardar, no hace merge parcial). Un día sin franjas = el doctor no
// atiende ese día. Soporta cualquier cantidad de franjas por día (horario partido, etc.).
// Componente controlado: quien lo usa hace el fetch inicial y el guardado (PUT
// /doctors/{id}/availability); este componente solo edita el arreglo en memoria.
export default function DoctorAvailabilityEditor({ value, onChange }) {
  const slots = value || [];

  const slotsForDay = (day) =>
    slots.map((s, i) => ({ ...s, _idx: i })).filter((s) => s.day_of_week === day);

  const setDayActive = (day, active) => {
    if (active) {
      onChange([...slots, { day_of_week: day, start_time: DEFAULT_START, end_time: DEFAULT_END }]);
    } else {
      onChange(slots.filter((s) => s.day_of_week !== day));
    }
  };

  const addSlot = (day) => {
    onChange([...slots, { day_of_week: day, start_time: DEFAULT_START, end_time: DEFAULT_END }]);
  };

  const removeSlot = (idx) => {
    onChange(slots.filter((_, i) => i !== idx));
  };

  const updateSlot = (idx, field, val) => {
    onChange(slots.map((s, i) => (i === idx ? { ...s, [field]: val } : s)));
  };

  return (
    <div className="space-y-2">
      {DAY_LABELS.map((label, day) => {
        const daySlots = slotsForDay(day);
        const active = daySlots.length > 0;
        return (
          <div key={day} className="border border-slate-200 rounded-lg p-2.5">
            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 text-sm font-medium text-slate-700 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={active}
                  onChange={(e) => setDayActive(day, e.target.checked)}
                  className="rounded border-slate-300 text-brand-electric focus:ring-blue-500"
                />
                {label}
              </label>
              {active && (
                <button
                  type="button"
                  onClick={() => addSlot(day)}
                  className="text-xs font-medium text-brand-electric hover:underline"
                >
                  + agregar franja
                </button>
              )}
            </div>
            {active && (
              <div className="mt-2 space-y-1.5">
                {daySlots.map((slot) => (
                  <div key={slot._idx} className="flex items-center gap-2">
                    <input
                      type="time"
                      value={slot.start_time}
                      onChange={(e) => updateSlot(slot._idx, "start_time", e.target.value)}
                      className="border border-slate-300 bg-white rounded-lg px-2 py-1 text-xs outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20"
                    />
                    <span className="text-slate-400 text-xs">a</span>
                    <input
                      type="time"
                      value={slot.end_time}
                      onChange={(e) => updateSlot(slot._idx, "end_time", e.target.value)}
                      className="border border-slate-300 bg-white rounded-lg px-2 py-1 text-xs outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-600/20"
                    />
                    <button
                      type="button"
                      onClick={() => removeSlot(slot._idx)}
                      className="text-rose-400 hover:text-rose-600 p-1 rounded"
                      title="Eliminar franja"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
